import { Text } from "@fluentui/react-components";

const FooterCopyright = () => <Text>Powered by SkyHighGrowth Inc.</Text>;

export default FooterCopyright;
